import { DefaultRootState } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';

export const annotationTasksStateSelector = ({ admin }: DefaultRootState) =>
  admin;

export const activeAnnotationTasksSelector = createSelector(
  annotationTasksStateSelector,
  ({ activeAnnotationTasks }) => activeAnnotationTasks,
);

export const inactiveAnnotationTasksSelector = createSelector(
  annotationTasksStateSelector,
  ({ inactiveAnnotationTasks }) => inactiveAnnotationTasks,
);

export const isLoadingSelector = createSelector(
  annotationTasksStateSelector,
  ({ isLoading }) => isLoading,
);

export const startDateParamsSelector = createSelector(
  annotationTasksStateSelector,
  ({ searchParams }) => searchParams.startDate,
);

export const endDateParamsSelector = createSelector(
  annotationTasksStateSelector,
  ({ searchParams }) => searchParams.endDate,
);

export const searchParamsSelector = createSelector(
  annotationTasksStateSelector,
  ({ searchParams }) => searchParams.searchInput,
);

export const selectedAnnotatorsSelector = createSelector(
  annotationTasksStateSelector,
  ({ searchParams }) => searchParams.selectedAnnotators,
);

export const selectedGridsSelector = createSelector(
  annotationTasksStateSelector,
  ({ searchParams }) => searchParams.selectedGrids,
);

export const selectedEffortsSelector = createSelector(
  annotationTasksStateSelector,
  ({ searchParams }) => searchParams.selectedEfforts,
);

export const activeTasksPageSelector = createSelector(
  annotationTasksStateSelector,
  ({ activeTasksPage }) => activeTasksPage,
);

export const inactiveTasksPageSelector = createSelector(
  annotationTasksStateSelector,
  ({ inactiveTasksPage }) => inactiveTasksPage,
);

export const annotatorsListSelector = createSelector(
  annotationTasksStateSelector,
  ({ annotatorsList }) => annotatorsList,
);

export const gridListSelector = createSelector(
  annotationTasksStateSelector,
  ({ annotationGridsList }) => annotationGridsList,
);
